/*
 * Copyright (c) 2020.
 * 页面点击时转链，替换淘点金组件
 * Company: www.gwdang.com
 * Author: wanghui
 * Email: wanghui@gwdang.com
 */

import TransUrl from '../Service/TransUrl'

TransUrl.run();

